export default "__VITE_ASSET__DUdKj3yX__"